import { render, staticRenderFns } from "./TrainingData.vue?vue&type=template&id=c2514902&scoped=true&"
import script from "./TrainingData.vue?vue&type=script&lang=js&"
export * from "./TrainingData.vue?vue&type=script&lang=js&"
import style0 from "./TrainingData.vue?vue&type=style&index=0&id=c2514902&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2514902",
  null
  
)

export default component.exports